import React from 'react'
import { hooks } from '@front/volcanion'

const withContainer = Component => () => {
  const [{ record_id, isManagingRecord }] = hooks.useFormState()

  const enableSubmitAll = !!isManagingRecord

  const mergedProps = {
    enableSubmitAll,
    record_id,
  }

  return (
    <Component {...mergedProps} />
  )
}

export default withContainer
